/**
 * Cmarkdownblockquote Component
 * Blockquote component for markdown rendering (>)
 */
"use client";
import type { ReactNode, CSSProperties } from "react";
import { Ccontainer } from "../Ccontainer";
import { getMarkdownBlockContainerStyle, getMarkdownBlockRootStyle, } from "../Cmarkdown/markdownBlockStyles";
import { ColorType } from "@/theme/colors";
/** The frame previously inherited the container preset's fat default
 *  (~23.5px); quotes are inline prose, not cards (issue ybg6fym). */
const BLOCKQUOTE_FRAME_PADDING = "12px 14px";
export interface CmarkdownblockquoteProps {
    children: ReactNode;
    className?: string;
    style?: CSSProperties;
    contentWrapperStyle?: CSSProperties;
    containerStyle?: CSSProperties;
    /** Hebrew-led quote: render right-to-left (accent edge moves to the right). */
    hebrew?: boolean;
}
// Hebrew quotes flip the accent edge (and its paired glow) to the right and set
// an RTL base direction; LTR keeps the original left-edge treatment.
const HEBREW_ACCENT_EDGE_STYLE: CSSProperties = {
    borderRight: `3px solid ${ColorType.Accent}`,
    backgroundImage: "radial-gradient(at 100% 70%, #01fce217 5%, #ffffff14 100%)",
    direction: "rtl",
};
const LTR_ACCENT_EDGE_STYLE: CSSProperties = {
    borderLeft: `3px solid ${ColorType.Accent}`,
    backgroundImage: "radial-gradient(at 0% 70%, #01fce217 5%, #ffffff14 100%)",
};
export function Cmarkdownblockquote({ children, className, style, contentWrapperStyle, containerStyle, hebrew = false, }: CmarkdownblockquoteProps) {
    const wrapperStyle = getMarkdownBlockRootStyle(style);
    const accentEdgeStyle = hebrew ? HEBREW_ACCENT_EDGE_STYLE : LTR_ACCENT_EDGE_STYLE;
    return (
      <div className={className} style={wrapperStyle}>
        <Ccontainer padding={BLOCKQUOTE_FRAME_PADDING} style={{
            ...getMarkdownBlockContainerStyle({
                ...accentEdgeStyle,
                boxShadow: "rgba(0, 0, 0, 0.5) 0px 4px 18px -8px, rgba(255, 255, 255, 0.02) 0px 1px 0px inset, #0ac5b23b 1px 0px 1px inset, #0ac5b23b -1px -1px 2px -1px inset",
            }),
            ...containerStyle,
        }} contentWrapperStyle={{
            padding: "0px 10px",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
            ...contentWrapperStyle,
        }}>
          {children}
        </Ccontainer>
      </div>
    );
}
